import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {MultiSelectComponent, MultiSelectFilter} from '../multi-select-component';
import {ToastService} from '../../services/toast.service';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDivider} from '@angular/material/divider';
import {MatButton} from '@angular/material/button';
import { DriversManagerService } from '../../../data/drivers/drivers-manager.service';
import { DriverWithShiftCount } from '../../models/driver.model';

/**
 * This component allows to create a multi-select filter of Driver entities.
 * It either emits 'undefined' value if no filter is set or an array of entities.
 *
 * In addition, it saves the state of the filter to URL params and browser's storage.
 */

@Component({
  selector: 'app-driver-filter',
  templateUrl: './driver-filter.component.html',
  styleUrls: ['./driver-filter.component.scss'],
  imports: [
    MatCheckbox,
    MatDivider,
    MatButton
  ]
})
export class DriverFilterComponent extends MultiSelectComponent<DriverWithShiftCount> implements OnInit {

  SETTINGS_KEY = 'selectedDriverIds';
  USE_FULLY_CHECKED_AS_DEFAULT = false;

  @Input() origin;
  @Output() filterChanged = new EventEmitter<MultiSelectFilter<DriverWithShiftCount>>();

  constructor(
    private driverManager: DriversManagerService,
    private readonly toast: ToastService,
  ) {
    super();
  }

  ngOnInit() {
    // delayed init to workaround failing chip label initialization :-(
    setTimeout(
      async () => this.initComponent(
        await this.driverManager.getDrivers()
      ),
      500,
    );
  }

  getLabel(item: DriverWithShiftCount): string {
    return `${item.givenName} ${item.familyName}`;
  }

  onApply() {}

}
